<template>
  <ga-product-card-favorite-button v-bind="data">
    <template #default="{ addToFavorites, isAdded, icon, isAnimating }">
      <ga-action
        :view="null"
        :class="
          b({ added: isAdded, animating: isAnimating && !isAdded, ...mods })
        "
        @click="$emit('click', { addToFavorites, isAdded, data })"
      >
        <ga-icon :class="b('icon')">
          <component :is="icon" />
        </ga-icon>
      </ga-action>
    </template>
  </ga-product-card-favorite-button>
</template>

<script src="./favorite.scripts.js" />

<style module src="./favorite.styles.scss" lang="scss" />
